import { createAction } from 'redux-actions';

const favouritesActions = {
  FAVOURITED_ITEM: 'FAVOURITED_ITEM',
  FAVOURITED_ITEM_SUCCESS: 'FAVOURITED_ITEM_SUCCESS',
  FAVOURITED_ITEM_ERROR: 'FAVOURITED_ITEM_ERROR',
  UNFAVOURITED_ITEM: 'UNFAVOURITED_ITEM',
  UNFAVOURITED_ITEM_SUCCESS: 'UNFAVOURITED_ITEM_SUCCESS',
  UNFAVOURITED_ITEM_ERROR: 'UNFAVOURITED_ITEM_ERROR',
  GET_FAVOURITED_ITEM: 'GET_FAVOURITED_ITEM',
  GET_FAVOURITED_ITEM_SUCCESS: 'GET_FAVOURITED_ITEM_SUCCESS',
  GET_FAVOURITED_ITEM_ERROR: 'GET_FAVOURITED_ITEM_ERROR',
  GET_BY_FAVOURITED_ITEM: 'GET_BY_FAVOURITED_ITEM',
  GET_BY_FAVOURITED_ITEM_SUCCESS: 'GET_BY_FAVOURITED_ITEM_SUCCESS',
  GET_BY_FAVOURITED_ITEM_ERROR: 'GET_BY_FAVOURITED_ITEM_ERROR',
  RECORD_FAVOURITED_ITEM: 'RECORD_FAVOURITED_ITEM',
  RECORD_FAVOURITED_ITEM_SUCCESS: 'RECORD_FAVOURITED_ITEM_SUCCESS',
  RECORD_FAVOURITED_ITEM_ERROR: 'RECORD_FAVOURITED_ITEM_ERROR',
  REMOVE_FAVOURITE_ITEM: 'REMOVE_FAVOURITE_ITEM',
  ADD_FAVOURITE_ITEM: 'ADD_FAVOURITE_ITEM',
};

const actionCreators = {
  itemFavourited: createAction(favouritesActions.FAVOURITED_ITEM),
  itemFavouritedSuccess: createAction(
    favouritesActions.FAVOURITED_ITEM_SUCCESS
  ),
  itemFavouritedError: createAction(favouritesActions.FAVOURITED_ITEM_ERROR),
  itemUnFavourited: createAction(favouritesActions.UNFAVOURITED_ITEM),
  itemUnFavouritedSuccess: createAction(
    favouritesActions.UNFAVOURITED_ITEM_SUCCESS
  ),
  itemUnFavouritedError: createAction(
    favouritesActions.UNFAVOURITED_ITEM_ERROR
  ),
  getItemFavourited: createAction(favouritesActions.GET_FAVOURITED_ITEM),
  getItemFavouritedSuccess: createAction(
    favouritesActions.GET_FAVOURITED_ITEM_SUCCESS
  ),
  getItemFavouritedError: createAction(
    favouritesActions.GET_FAVOURITED_ITEM_ERROR
  ),

  getByIdItemFavourited: createAction(favouritesActions.GET_BY_FAVOURITED_ITEM),
  getByIdItemFavouritedSuccess: createAction(
    favouritesActions.GET_BY_FAVOURITED_ITEM_SUCCESS
  ),
  getByIdItemFavouritedError: createAction(
    favouritesActions.GET_BY_FAVOURITED_ITEM_ERROR
  ),

  getRecordItemFavourited: createAction(
    favouritesActions.RECORD_FAVOURITED_ITEM
  ),
  getRecordItemFavouritedSuccess: createAction(
    favouritesActions.RECORD_FAVOURITED_ITEM_SUCCESS
  ),
  getRecordItemFavouritedError: createAction(
    favouritesActions.RECORD_FAVOURITED_ITEM_ERROR
  ),
  removeFavouriteItems: createAction(favouritesActions.REMOVE_FAVOURITE_ITEM),
  addFavouriteItem: createAction(favouritesActions.ADD_FAVOURITE_ITEM),
};

export { favouritesActions as types, actionCreators };
